/**
 * Permissão de ação na etapa atual do processo de contratação.
 * Bypass: admin / gerência (`podeGerenciarProcessos`).
 * Lista vazia de responsáveis: somente bypass (comportamento legado).
 */

export function parseResponsaveisIds(raw) {
  if (raw == null || raw === '') return [];
  let arr = raw;
  if (typeof raw === 'string') {
    try {
      arr = JSON.parse(raw);
    } catch {
      arr = raw.split(',').map((s) => s.trim()).filter(Boolean);
    }
  }
  if (!Array.isArray(arr)) return [];
  return arr.map((x) => Number(x)).filter((n) => !Number.isNaN(n));
}

export function nomesResponsaveisEtapa(responsaveisIds, usuarios = []) {
  const ids = parseResponsaveisIds(responsaveisIds);
  if (!ids.length) return [];
  return ids.map((id) => {
    const u = (usuarios || []).find((x) => Number(x.id) === Number(id));
    return u?.nome || u?.email || `ID ${id}`;
  });
}

/**
 * @returns {{ canAct: boolean, responsaveisIds: number[], nomes: string[], mensagem: string|null }}
 */
export function avaliarPermissaoEtapaProcesso({
  user,
  etapa,
  podeGerenciarProcessos = false,
  usuarios = [],
}) {
  const responsaveisIds = parseResponsaveisIds(
    etapa?.responsaveisIds ?? etapa?.responsaveis_ids ?? etapa?.responsaveis
  );
  const nomes = nomesResponsaveisEtapa(responsaveisIds, usuarios);

  if (podeGerenciarProcessos) {
    return { canAct: true, responsaveisIds, nomes, mensagem: null };
  }

  if (responsaveisIds.length === 0) {
    return {
      canAct: false,
      responsaveisIds,
      nomes,
      mensagem:
        'Você não é responsável por esta etapa. Apenas gestores de contratos ou administradores podem agir aqui (nenhum responsável específico configurado).',
    };
  }

  const uid = Number(user?.id);
  const email = String(user?.email || '')
    .trim()
    .toLowerCase();
  const inListById = !Number.isNaN(uid) && responsaveisIds.includes(uid);
  const inListByEmail =
    Boolean(email) &&
    (usuarios || []).some(
      (u) =>
        responsaveisIds.includes(Number(u.id)) &&
        String(u.email || '')
          .trim()
          .toLowerCase() === email
    );

  if (inListById || inListByEmail) {
    return { canAct: true, responsaveisIds, nomes, mensagem: null };
  }

  const listaNomes = nomes.length ? nomes.join(', ') : 'os responsáveis configurados';
  return {
    canAct: false,
    responsaveisIds,
    nomes,
    mensagem: `Você não é responsável por esta etapa. Apenas ${listaNomes} podem agir aqui.`,
  };
}
